import { forwardRef } from 'react';
import { postfixTestId } from '../../../util/testId';
import { Flow } from '../../Layouts/Flow';
import { ObjectMarker } from '../../ObjectMarker';
import './TileFooter.css';
import cn from './TileFooter.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
export const TileFooter = /*#__PURE__*/forwardRef(function TileFooter({
  objectMarkers = [],
  ...props
}, ref) {
  if (!props.children && objectMarkers.length === 0) return null;
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    "data-testid": props.testId,
    className: cn.fullWidth,
    children: props.children ?? /*#__PURE__*/_jsx(Flow, {
      spacing: "xxs",
      className: cn.fullWidth,
      children: objectMarkers.map((objectMarkerProps, i) =>
      /*#__PURE__*/
      // Add this extra div because ObjectMarker uses Flow at the root level, which would override the spacing
      // set by the Flow of the object markers container
      _jsx("div", {
        children: /*#__PURE__*/_jsx(ObjectMarker, {
          testId: postfixTestId(props.testId, `objectMarker-${i}`),
          ...objectMarkerProps,
          hideLabel: objectMarkerProps.hideLabel ||
          // If more than one object marker is surfaced in the footer,
          // all inactive object markers are changed to icon-only.
          objectMarkers.length > 1 && !objectMarkerProps.popperText
        })
      }, i))
    })
  });
});
//# sourceMappingURL=TileFooter.js.map